const services = {
  hero: {
    title: "Nuestros Servicios",
    subtitle: "Servicios profesionales de limpieza y reparación adaptados a tus necesidades.",
    breadcrumb: "Servicios",
  },
  categories: {
    cleaning: {
      title: "Servicios de Limpieza",
      count: "4 servicios disponibles",
      desc: "Desde mantenimiento regular hasta limpieza profunda — lo manejamos todo.",
    },
    handyman: {
      title: "Servicios de Reparación",
      count: "10 servicios disponibles",
      desc: "Reparaciones, instalaciones y mejoras para cada parte de tu hogar.",
    },
  },
  cleaning: {
    sectionTitle: "Servicios de Limpieza",
    items: [
      {
        slug: "residential-cleaning",
        title: "Limpieza Residencial",
        shortDesc: "Limpieza profesional regular para mantener tu hogar fresco y ordenado cada semana.",
        image: "https://readdy.ai/api/search-image?query=professional%20residential%20house%20cleaning%20service%20bright%20modern%20living%20room%20sparkling%20clean%20surfaces%20white%20walls%20natural%20light&width=600&height=400&seq=rc1&orientation=landscape",
      },
      {
        slug: "deep-cleaning",
        title: "Limpieza Profunda",
        shortDesc: "Limpieza exhaustiva de arriba a abajo para un hogar verdaderamente impecable.",
        image: "https://readdy.ai/api/search-image?query=deep%20cleaning%20service%20professional%20cleaner%20scrubbing%20kitchen%20bathroom%20tiles%20bright%20clean%20home%20detailed%20cleaning&width=600&height=400&seq=dc1&orientation=landscape",
      },
      {
        slug: "move-in-out-cleaning",
        title: "Limpieza de Mudanza",
        shortDesc: "Prepara tu hogar para nuevos comienzos — perfectamente limpio al llegar o salir.",
        image: "https://readdy.ai/api/search-image?query=move%20in%20move%20out%20cleaning%20empty%20house%20professional%20cleaning%20service%20bright%20rooms%20clean%20floors%20walls&width=600&height=400&seq=mo1&orientation=landscape",
      },
      {
        slug: "airbnb-cleaning",
        title: "Limpieza Airbnb",
        shortDesc: "Cambios rápidos y confiables para mantener a tus huéspedes felices y con reseñas de 5 estrellas.",
        image: "https://readdy.ai/api/search-image?query=airbnb%20vacation%20rental%20cleaning%20service%20fresh%20bed%20linens%20bright%20bedroom%20clean%20bathroom%20professional%20hospitality&width=600&height=400&seq=ab1&orientation=landscape",
      },
    ],
  },
  handyman: {
    sectionTitle: "Servicios de Reparación",
    items: [
      {
        slug: "drywall-repair",
        title: "Reparación de Drywall",
        shortDesc: "Hoyos, grietas y daños — restauramos tus paredes a la perfección.",
        image: "https://readdy.ai/api/search-image?query=drywall%20repair%20professional%20handyman%20patching%20wall%20holes%20smooth%20finish%20white%20wall%20home%20repair&width=600&height=400&seq=dw1&orientation=landscape",
      },
      {
        slug: "door-repairs",
        title: "Reparación de Puertas",
        shortDesc: "Cerraduras, bisagras, alineación — reparamos todos los problemas de puertas.",
        image: "https://readdy.ai/api/search-image?query=door%20repair%20handyman%20fixing%20door%20lock%20hinge%20alignment%20residential%20home%20interior%20professional%20service&width=600&height=400&seq=dr1&orientation=landscape",
      },
      {
        slug: "cabinet-fixes",
        title: "Reparación de Gabinetes",
        shortDesc: "Bisagras sueltas, cajones rotos, puertas desalineadas — manejamos todas las reparaciones.",
        image: "https://readdy.ai/api/search-image?query=cabinet%20drawer%20repair%20handyman%20fixing%20kitchen%20cabinet%20hinges%20drawers%20home%20improvement%20professional&width=600&height=400&seq=cf1&orientation=landscape",
      },
      {
        slug: "interior-painting",
        title: "Pintura Interior y Retoques",
        shortDesc: "Capas frescas y retoques precisos para que tus paredes luzcan como nuevas.",
        image: "https://readdy.ai/api/search-image?query=interior%20painting%20professional%20painter%20rolling%20white%20paint%20on%20wall%20bright%20clean%20room%20home%20improvement&width=600&height=400&seq=ip1&orientation=landscape",
      },
      {
        slug: "tv-mounting",
        title: "Instalación de TV",
        shortDesc: "Instalación segura y limpia con manejo de cables para un acabado impecable.",
        image: "https://readdy.ai/api/search-image?query=tv%20mounting%20installation%20professional%20handyman%20mounting%20flat%20screen%20television%20on%20wall%20modern%20living%20room&width=600&height=400&seq=tv1&orientation=landscape",
      },
      {
        slug: "furniture-assembly",
        title: "Ensamblaje de Muebles",
        shortDesc: "Ensamblamos todo tipo de muebles de forma rápida y correcta.",
        image: "https://readdy.ai/api/search-image?query=furniture%20assembly%20professional%20handyman%20assembling%20ikea%20furniture%20bedroom%20living%20room%20home%20service&width=600&height=400&seq=fa1&orientation=landscape",
      },
      {
        slug: "pressure-washing",
        title: "Lavado a Presión",
        shortDesc: "Limpieza potente para entradas, patios, cercas y superficies exteriores.",
        image: "https://readdy.ai/api/search-image?query=pressure%20washing%20driveway%20patio%20professional%20cleaning%20service%20powerful%20water%20jet%20clean%20concrete%20outdoor&width=600&height=400&seq=pw1&orientation=landscape",
      },
      {
        slug: "gutter-cleaning",
        title: "Limpieza de Canaletas",
        shortDesc: "Limpia las canaletas obstruidas para proteger tu hogar de daños por agua.",
        image: "https://readdy.ai/api/search-image?query=gutter%20cleaning%20professional%20service%20removing%20leaves%20debris%20from%20roof%20gutters%20residential%20home%20maintenance&width=600&height=400&seq=gc1&orientation=landscape",
      },
      {
        slug: "fence-repairs",
        title: "Reparación de Cercas",
        shortDesc: "Repara cercas rotas o inclinadas para restaurar la seguridad y el atractivo.",
        image: "https://readdy.ai/api/search-image?query=fence%20repair%20professional%20handyman%20fixing%20wooden%20fence%20residential%20backyard%20home%20improvement%20outdoor&width=600&height=400&seq=fr1&orientation=landscape",
      },
      {
        slug: "landscaping",
        title: "Jardinería Pequeña",
        shortDesc: "Cuidado del césped, poda y jardinería pequeña para mantener tu jardín hermoso.",
        image: "https://readdy.ai/api/search-image?query=small%20landscaping%20service%20professional%20lawn%20care%20trimming%20plants%20residential%20yard%20beautiful%20green%20garden%20Florida&width=600&height=400&seq=ls1&orientation=landscape",
      },
    ],
  },
};

export default services;
